import { EventComponent, NoEventsComponent } from ".";
import * as React from "react";
import * as RS from "react-sortable-hoc";
import * as M from "../../../../models";
import { Utility } from "../../../../utils";

interface OwnProps {
    day: M.Event.CalendarDay;
    isSearch: boolean;
    onEventDeleteClick: (evt: M.Event.SubEvent) => void;
    onEventEditClick: (evt?: M.Event.SubEvent) => void;
    onRsvpExportClick: (evtId: number) => void;
    onSessionAbstractClick: (abstractId: number) => void;
    onSessionEditClick: (parent: M.Event.SubEvent, evt?: M.Event.SubEvent) => void;
    onSessionsSorted: (parentId: number, sortEnd: RS.SortEnd) => void;
}

interface OwnState {
}

export class DayView extends React.Component<OwnProps, OwnState> {

    public render() {
        const day = this.props.day;

        return <li className="schedule-day">
            <h2 className="schedule-day-title">{day.dayFormatted_dddMMMD}</h2>
            <ol className="schedule-day-event-list">
                {day.events.size
                    ? day.events
                        .sortBy((evt: M.Event.SubEvent, i) => Utility.utcToValue(evt.startDate))
                        .map((evt: M.Event.SubEvent, i) => {
                        return <li key={i}>
                                <EventComponent
                                    key={i}
                                    event={evt}
                                    isSearch={this.props.isSearch}
                                    onEventEditClick={this.props.onEventEditClick}
                                    onEventDeleteClick={this.props.onEventDeleteClick}
                                    onRsvpExportClick={(evtId) => this.props.onRsvpExportClick(evtId)}
                                    onSessionAbstractClick={(this.props.onSessionAbstractClick)}
                                    onSessionEditClick={this.props.onSessionEditClick}
                                    onSessionsSorted={this.props.onSessionsSorted}
                                />
                        </li>;
                    })
                : <li>
                    <NoEventsComponent onEventAddClick={() => this.props.onEventEditClick()} />
                </li>}
            </ol>
        </li>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminEvent/editCalendar/components/DayComponent.tsx